const Achievements = props => {
  return (
    <div className="flex px-7 lg:px-10 xl:px-28 bg-blue-500">
      <div className="flex flex-col">
        <div className="flex flex-col lg:flex-row py-7 md:py-20 border-b border-white border-opacity-30">
          <span className="flex w-full text-white font-headline font-extrabold text-3xl sm:text-4xl lg:text-5xl items-center pb-6 md:pb-0">
            RISC V processor cores
          </span>
          <span className="flex w-full text-white font-headline font-light text-xl sm:text-2xl lg:text-3xl">
            Delivered validated designs of various types of RISC-V processor
            cores including CVA6 and PULP with SPE verification for vector
            operations and FPU pipeline verification
          </span>
        </div>
        <div className="flex flex-col lg:flex-row py-7 md:py-20 border-b border-white border-opacity-30">
          <span className="flex w-full text-white font-headline font-extrabold text-3xl sm:text-4xl lg:text-5xl items-center pb-6 md:pb-0">
            RISC-V ISA verification
          </span>
          <span className="flex w-full text-white font-headline font-light text-xl sm:text-2xl lg:text-3xl">
            Custom ISA verification for vector operations utilizing Google
            riscv-test and riscv-tourture using SPIKE model on CVA6 RISC-V
            processor architecture
          </span>
        </div>
        <div className="flex flex-col lg:flex-row py-7 md:py-20 border-b border-white border-opacity-30">
          <span className="flex w-full text-white font-headline font-extrabold text-3xl sm:text-4xl lg:text-5xl items-center pb-6 md:pb-0">
            Memory Subsystem models
          </span>
          <span className="flex w-full text-white font-headline font-light text-xl sm:text-2xl lg:text-3xl">
            Delivered validated designs of various types of RISC-V processor
            cores including CVA6 and PULP with SPE verification for vector
            operations and FPU pipeline verification
          </span>
        </div>
        <div className="flex flex-col lg:flex-row py-7 md:py-20 border-b border-white border-opacity-30">
          <span className="flex w-full text-white font-headline font-extrabold text-3xl sm:text-4xl lg:text-5xl items-center pb-6 md:pb-0">
            Digital communication
          </span>
          <span className="flex w-full text-white font-headline font-light text-xl sm:text-2xl lg:text-3xl">
            Developed multiple digital communication port protocol hardware
            designs including AXI (AXI4, AXI4Stream, AXI4lite), APB, Ethernet,
            and serial (USB, I2C, SPI, UART)
          </span>
        </div>
        <div className="flex flex-col lg:flex-row py-7 md:py-20 border-b border-white border-opacity-30">
          <span className="flex w-full text-white font-headline font-extrabold text-3xl sm:text-4xl lg:text-5xl items-center pb-6 md:pb-0">
            Advanced Bus bridges
          </span>
          <span className="flex w-full text-white font-headline font-light text-xl sm:text-2xl lg:text-3xl">
            Design and verification of bus bridges, adapters, and converters for
            AXI4-to-APB, AXI4stream-to-AXI4, AXI-Xbar, SerDes, etc.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
